import * as tslib_1 from "tslib";
import * as React from 'react';
export function withSentryErrorBoundary(ComponentToWrap, options, ErrorStateComponent) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(SentryErrorBoundary, _super);
        function SentryErrorBoundary() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                error: null,
            };
            return _this;
        }
        SentryErrorBoundary.prototype.getRaven = function () {
            return this.props.host.raven;
        };
        SentryErrorBoundary.prototype.getRavenUserContextOverrides = function () {
            return this.props.ravenUserContextOverrides;
        };
        SentryErrorBoundary.prototype.componentDidCatch = function (error) {
            if (this.state.error === null) {
                this.setState({ error: error });
            }
            var raven = this.getRaven();
            if (!raven) {
                return;
            }
            raven.config(options.dsn, options.config);
            var userContextOverrides = this.getRavenUserContextOverrides();
            if (options.userContext || userContextOverrides) {
                raven.setUserContext(tslib_1.__assign({}, options.userContext, userContextOverrides));
            }
            raven.captureException(error);
        };
        SentryErrorBoundary.prototype.render = function () {
            return this.state.error && ErrorStateComponent ? (React.createElement(ErrorStateComponent, tslib_1.__assign({ error: this.state.error }, this.props))) : (React.createElement(ComponentToWrap, tslib_1.__assign({}, this.props)));
        };
        return SentryErrorBoundary;
    }(React.Component));
}
//# sourceMappingURL=sentryErrorBoundary.js.map